export default __webpack_public_path__ + "static/media/famille-de-plats.5c2383c6.svg";